import {
  useTenantCancel,
  useTenantCreate,
  useTenantDelete,
  useTenantGet,
  useTenantGetSuspense,
  useTenantRevival,
  useTenantUpdate,
} from "@/api/generated/endpoints/api"
import {
  tenantCancelBody,
  tenantCancelParams,
  tenantCreateBody,
  tenantGetParams,
  tenantUpdateBody,
} from "@/api/generated/schemas/api.zod"

export * as TenantModels from "./models"

export const tenantApi = {
  // Query Hooks
  useTenantGet,
  useTenantGetSuspense,

  // Mutation Hooks
  useTenantCreate,
  useTenantUpdate,
  useTenantCancel,
  useTenantRevival,
  useTenantDelete,
}

export const tenantSchemas = {
  tenantCreateBody,
  tenantUpdateBody,
  tenantCancelBody,
  tenantCancelParams,
  tenantGetParams,
}
